"use strict";

var _core = require("../core");

var _reactBatchedUpdates = require("./reactBatchedUpdates");

_core.notifyManager.setBatchNotifyFunction(_reactBatchedUpdates.unstable_batchedUpdates);


//////////////////
// WEBPACK FOOTER
// ./~/react-query/lib/react/setBatchUpdatesFn.js
// module id = 2047
// module chunks = 0